module.exports = __webpack_public_path__ + "img/jointask.d6e225f0.png";